import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SizeDirective } from '../../directives';

@Component({
    selector: 'lui-lsos-logo',
    imports: [CommonModule],
    templateUrl: './lsos-logo.component.html',
    styleUrls: ['./lsos-logo.component.scss'],
    hostDirectives: [{ directive: SizeDirective, inputs: ['width', 'height'] }]
})
export class LsosLogoComponent {}
